import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'widgets';
export const keyPrefix = 'departmentGeneralInfo';

export const useDepartmentGeneralInfoTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Общая информация',
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'General Information',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Información general',
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Informações gerais',
  },
}) : {}) as Record<string, unknown>;
